<template>
    <section class="experience-section" id="projects">
        <div class="experience-container text-in-1">
            <h3 class="inter-500">Experiencia</h3>
            <BaseCard :value="experienceArray" />
        </div>

    </section>
</template>

<script setup lang="ts">
import { Experience } from '@/interfaces/experience.interface';
import BaseCard from './BaseCard.vue';

const experienceArray: Experience[] = [
    {
        title: "Desarrollador COBOL, Stefanini México S.A de C.V",
        date: "Noviembre 2022 - Marzo 2026",
        activities: [
            "Redaccion de documentacion tecnica de los requerimientos del usuario.",
            "Analisis, desarrollo e implementacion de requerimeintos funcionales empleando COBOL74 como lenguaje de programacion.",
            "Implementacion de nuevos modulos, mantenimeinto y robostecimiento de modolos existentens en diversos sistemas de Banamex.",
            "Desarrollo de pruebas unitarias e integrales en plataformas de ClearPath MCP (Unisys)",
        ]
    },
    {
        title: "Desarrollador Web",
        date: "Agosto 2021 - Diciembre 2021",
        activities: [
            "Colaboré en el desarrollo de una PWA para la comunidad del ITTG - Instituto Tecnológico de Tuxtla Gutiérrez, con la finalidad de difundir comunicados importantes del Instituto, implementando tecnologías como: HTML, CSS, JavaScript, Laravel y Vue3."
        ]
    },
    {
        title: "Desarrollador Web",
        date: "Enero 2024 - Marzo 2024",
        activities: [
            "Colaboré en el desarrollo de una aplicación web para el control de los animales de un rancho, implementando las siguientes tecnologias: HTML, CSS, JavaScript, Laravel y Vue3."
        ]
    },
    {
        title: "Educación",
        date: "Agosto 2017- Diciembre 2021",
        activities: [
            "Universidad Tecnológico Nacional de México - Campus Tuxtla Gutiérrez, Chiapas.",
            "Licenciatura en Sistemas Computacionales(titulado)",
            "Ingles - Nivel B1 (Harmon Hall)"
        ]
    },
]


</script>

<style scoped>
.experience-section {
    background-color: var(--main-bg-color);
}
.experience-container{
    width: 100%;
}
h3 {
    background-color: var(--secondary-bg-color);
    color: var(--main-bg-color);
    text-transform: uppercase;
    width: max-content;
    font-size: 1em;
    padding: 0.4em;
    border-radius: 0.3em;
    margin: 1em;
    margin-bottom: 0;
}

@media (min-width: 576px) {
    .experience-container {
        width: 70%;
        margin: auto;
        padding: 3em;
    }
}
</style>